export const SCHEMA_NAME= 'flowVariable';
export const COMMAND_NAME = "flowVariable"
export const TOOLBAR_LABEL = "变量选择"
export const TOOLBAR_NAME= "flowVariable"
export const UI_NAME= "flowVariableUi"
export const WIDGET_TOOLBAR_NAME="flowVariable-toolbar"
export const COMMAND_NAME_EDIT= "flowVariable-edit"
export const BALLOONCLASSNAME  = "编辑变量"